import httpServer from "../axios";
import {baseUrlt} from "..";

export default {
  deleteTarinRoom(params){
    return httpServer('get',`${baseUrlt}api/training/room/delete/${params.id}` );
  },
  deleteMethod(params){
    return httpServer('delete',`${baseUrlt}api/class/train/log/delete/${params.id}` );
  },
  deleteJournalOfClass(params){
    return httpServer('delete',`${baseUrlt}api/class/train/class_log/delete/${params.id}` );
  },
  deleteEqJournal(params){
    return httpServer('delete',`${baseUrlt}api/class/charge/teacher/delete/${params.id}` );
  },
  deleteDeviceInto(params){
    return httpServer('get',`${baseUrlt}api/device/delete`,params );
  },
  deleteDeviceBuy(params){
    return httpServer('get',`${baseUrlt}api/devicepurchase/delete`,params );
  },
  deleteDeviceScrap(params){
    return httpServer('get',`${baseUrlt}api/devicescrap/delete`,params );
  },
  deleteDeviceRepair(params){
    return httpServer('get',`${baseUrlt}api/devicerepair/delete`,params );
  },
  deleteDeviceKeep(params){
    return httpServer('get',`${baseUrlt}api/devicekeep/delete`,params );
  },
  deleteDeviceBorrow(params){
    return httpServer('get',`${baseUrlt}api/deviceborrow/delete`,params );
  },
  deleteDeviceLend(params){
    return httpServer('get',`${baseUrlt}api/devicelend/delete`,params );
  },
  deleteDeviceReturn(params){
    return httpServer('get',`${baseUrlt}api/devicereturn/delete`,params );
  },
  deleteDeviceCount(params){
    return httpServer('get',`${baseUrlt}api/devicetotal/delete`,params );
  },
  deleteConsumeInto(params){
    return httpServer('delete',`${baseUrlt}api/consume/delete/${params.id}`);
  },
  deleteConsumeUser(params){
    return httpServer('delete',`${baseUrlt}api/consume/record/delete/${params.id}`);
  },
  deleteOrgan(params){
    return httpServer('post',`${baseUrlt}api/school/structure/delete`,params);
  },
  deleteUser(params){
    return httpServer('post',`${baseUrlt}api/user/delete`,params);
  },
  deleteQItem(params){
    return httpServer('post',`${baseUrlt}api/grade/index/delete`,params);
  },
  deleteFile(params){
    return httpServer('post',`${baseUrlt}api/file/delete`,params);
  },
  cancelBind(params){
    return httpServer('get',`${baseUrlt}api/training/room/device/delete`,params);
  },
  deleteRule(params){
    return httpServer('get',`${baseUrlt}api/training/room/standard/delete`,params);
  },
  deleteItem(params){
    return httpServer('post',`${baseUrlt}api/training_plan/planScoreItemDelete`,params);
  },
  deletePlan(params){
    return httpServer('post',`${baseUrlt}api/training_plan/delete`,params);
  },
  deletePlanV2(params){
    return httpServer('delete',`${baseUrlt}api/training_plan/v2/delete/${params.id}`);
  },
  deleteTrainBase(params){
    return httpServer('post',`${baseUrlt}api/training_base/delete`,params);
  },
  deleteMessage(params){
    return httpServer('post',`${baseUrlt}api/message/delete`,params);
  },
  deleteSchool(params){
    return httpServer('post',`${baseUrlt}api/school/admin/delete`,params);
  },
  deleteCourse(params){
    return httpServer('delete',`${baseUrlt}api/xmhy/class/plan/delete/${params.id}`);
  },
  deleteTrainRommOpen(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/open/delete`,params);
  },
  deleteTrainRommCup(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/computer_use/delete`,params);
  },
  deleteTrainRommFunds(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/funds/delete`,params);
  },
  deleteTrainBaseOut(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/delete`,params);
  },
  deleteTrainBaseOutItem(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/baseScoreItemDelete`,params);
  },
  deleteTrainBaseOutYear(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/baseScoreYearDelete`,params);
  },
  deletPurchase(params){
    return httpServer('post',`${baseUrlt}api/consume/purchase/delete`,params);
  },
  deletDevicePurchase(params){
    return httpServer('post',`${baseUrlt}api/device/purchase2/delete`,params);
  },
  deleteStudentGrade(params){
    return httpServer('post',`${baseUrlt}api/grade/delete`,params);
  },
};